const isObject = (value) => !!value && typeof value === 'object' && !Array.isArray(value)

/**
 * A function to merge 2 objects and return a new object
 * @param {*} targetObject Target object
 * @param {*} sourceObject Source object
 * @param {*} options
 * @returns Merged object
 */
export const deepMergeTwo = (targetObject, sourceObject, { mutate = false } = {}) => {
  if (!sourceObject) {
    return targetObject
  }

  if (!isObject(targetObject) || !isObject(sourceObject)) {
    throw new Error('deepMerge: target and source must be objects')
  }

  let newObject
  if (mutate) {
    newObject = Object.assign(targetObject, sourceObject)
  } else {
    newObject = Object.assign({}, targetObject, sourceObject)
  }

  Object.entries(sourceObject).forEach(([sourceKey, sourceValue]) => {
    const targetValue = targetObject?.[sourceKey]
    if (sourceValue === undefined) {
      newObject[sourceKey] = targetValue
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      newObject[sourceKey] = deepMergeTwo(targetValue, sourceValue)
    }
  })

  return newObject
}
